export const Api = Object.freeze({
	API: {
        GET_APP_DATA: '/Api/GetAppData',
        GET_APP_DATA_NO_AUTH: '/Api/GetAppDataNoAuth',
        GET_LINKS: '/Api/GetLinks',
        GET_FILE_OR_LINK: '/Api/GetFileOrLink',
        GET_PA_CRITERIA: '/Api/GetPaCriteria',
        GET_FORMULARY_EXTRACT: '/Api/GetFormularyExtract',
        SEND_CONTACT_US_FORM: '/Api/SendContactUsForm'
	},

	AUTH: {
		SIGN_OUT: '/Auth/SignOut'
    },

    HOME: {
        SEARCH_PHARMACIES: '/Home/SearchPharmacies',
        GET_RELEASE_INFO: '/Home/GetReleaseInfo'
    },

    MEMBER: {
        VALIDATE_MEMBER: '/Member/ValidateMember',
        REGISTER_ACCOUNT: '/Member/RegisterAccount',
        LOOKUP_USERNAME: '/Member/LookupUsername',
        SEARCH_MEMBERS: '/Member/SearchMembers',
        MASQUERADE: '/Member/Masquerade',
        CLEAR_MASQUERADE: '/Member/ClearMasquerade',
        GET_MASQUERADE: '/Member/GetMasquerade',
        GET_LINKS: '/Member/GetLinks',
        GET_FILE_OR_LINK: '/Member/GetFileOrLink',
        GET_MEMBER_CARD_DATA: '/Member/GetMemberCardData'
    },

	METHOD: {
		GET: 'get',
		POST: 'post'
	},
})

export const Layout = Object.freeze({
	DEFAULT: 'default',
	MAIN: 'main'
})

export const LinkGroup = Object.freeze({
    FORMS: 1,
    GENERIC_UPDATES: 2,
    HEALTHY_EATING: 3,
    NEWS: 4,
    PHYSICAL_FITNESS: 5,
    QUIZZES: 7,
    WELLNESS_LINKS: 8
})

export const MemberLinkGroup = Object.freeze({
    DOCUMENTS: 1,
    DRUG_LISTS: 2
})

export const Role = Object.freeze({
	HAS_ACCESS: 'HasAccess',
    ADMIN: 'Admin',
})

export const RouteName = Object.freeze({
    SIGN_IN: 'sign-in',
})

export const RouteTitle = Object.freeze({
    DEFAULT_TITLE: 'MyMaxCareRx',
    HELPFUL_DOCUMENTS: 'Helpful Documents',
    PRIOR_AUTH_CRITERIA: 'Prior Authorization Criteria',
    CONTACT_US: 'Contact Us',
    WELLNESS: 'Wellness',
    SIGN_IN: 'Sign In',
    MY_BENEFITS: 'My Benefits',
    MY_BENEFITS_OVERVIEW: 'Overview',
    DRUG_LISTS: 'Drug Lists',
	ID_CARD: 'ID Card',
})

export const Url = Object.freeze({
    HOMEPAGE: '/',
    HELPFUL_DOCUMENTS: '/helpfulDocuments',
    PRIOR_AUTH_CRITERIA: '/priorAuthCriteria',
    WELLNESS: '/wellness',
    CONTACT_US: '/contact',
    MY_BENEFITS_OLD: '/myBenefits',
    MY_BENEFITS: 'https://mymaxcarerx.myrxplan.com',
    SIGN_IN: '/myBenefits/signIn',
    MY_BENEFITS_OVERVIEW: '/myBenefits/overview',
    DRUG_LISTS: '/myBenefits/drugLists',
    ID_CARD: '/myBenefits/idCard',
})